export default {
    FULL_NAME: 'Full Name',
    NAME: 'Name',
    EMAIL: 'Email',
    COMPANY: 'Company',
    CREATION_DATE: 'Creation Date',
    PHONE: 'Phone',
    ACTIONS: 'Actions',
    COMPANY_OWNER: 'Owner',
    DOMAIN: 'Domain',
    DEVICE_ID: 'Device ID',
    STATUS: 'Status',
    CONNECTED_ACCOUNT: 'Connected Account',
    ADDRESS: 'Address',
    CITY: 'City',
    TERMINAL: 'Terminal',
    CATEGORY: 'Category',
    PRICE: 'Price',
    DISCOUNTED_PRICE: 'Discounted Price',
    AVAILABILITY: 'Availability',
    MULTI_SELECT: 'Multi Select',
    MAX_SELECTIONS: 'Max Selections',
    TYPE: 'Type',
    PAGE: 'Page',
    START_DATE: 'Start Date',
    END_DATE: 'End Date',
    END_USER: 'End User',
    TOTAL_PRICE: 'Total Price',
    ORDER_STATUS: 'Order Status',
    DELIVERY_METHOD: 'Delivery Method',
    PAYMENT_METHOD: 'Payment Method',
};
